import React from 'react';
import ItemSelector from '../../shared/ItemSelector';
import { MultiSelect } from '../../shared/MultiSelect';

export const LineupsFilter = ({
  lastTwoMinutes,
  period,
  rotation,
  clutchGarbage,
  homeAway,
  conference,
  division,
  isNBA,
}) => {
  return (
    <div className="filter">
      <div className="form-row">
        <div className="form-column--xs">
          <div className="form-group">
            <label>Last 2 minutes</label>
            <ItemSelector {...lastTwoMinutes} />
          </div>
        </div>
        <MultiSelect
          title="Period"
          empty="(All)"
          items={period.items}
          onChange={period.onChange}
        />
        <div className="form-column--xs">
          <div className="form-group">
            <label>Rotation</label>
            <ItemSelector {...rotation} />
          </div>
        </div>
        <MultiSelect
          title="Clutch / Garbage"
          empty="(All)"
          items={clutchGarbage.items}
          onChange={clutchGarbage.onChange}
        />
        <div className="form-column--xs">
          <div className="form-group">
            <label>Home / Away</label>
            <ItemSelector {...homeAway} />
          </div>
        </div>
        <div className="form-column--xs">
          <div className="form-group">
            <label>Division</label>
            <ItemSelector {...division} disabled={isNBA} />
          </div>
        </div>
        <div className="form-column--xs">
          <div className="form-group">
            <label>Conference</label>
            <ItemSelector {...conference} />
          </div>
        </div>
      </div>
    </div>
  );
};
